package ui


import dataProperties
import react.FC
import react.Props

import emotion.react.css
import kotlinx.browser.window
import react.createElement
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import react.useState
import routes.EnumRoutes
import ui.components.ComponentPropertyRow
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import web.cssom.ClassName
import web.cssom.TextAlign
import web.cssom.minus
import web.cssom.pct
import web.cssom.px
import web.cssom.vh

external interface PagePropertiesProps: Props {
    var id: String
    var name: String
    var address: String
    var price: String
    var status: String
    var inquiries: Int
    var imageUrl: String
}

val tabs = listOf("All", "Active", "Pending", "Archived")


val PageProperties = FC<PagePropertiesProps> {
    val (activeTab, setActiveTab) = useState("All")

    val filteredProperties = dataProperties.filter {
        activeTab == "All" ||  it.status == activeTab
    }

    div {
        className = ClassName("min-h-screen bg-white flex relative")

        // Navigation
        NavBar{
            this.activeNavItem = "Properties"
        }

//        Main Content
        div{
//            className = ClassName("flex-1 p-4 lg:p-8 ml-0 lg:ml-0")
            css(ClassName("flex-1 p-4 lg:p-8 ml-0 lg:ml-0")) {
                height = 100.vh
            }
            // Title
            div {
                className = ClassName("flex justify-center py-6 px-4")
                h1 {
                    className = ClassName("text-xl md:text-2xl text-boon-primary font-normal text-center")
                    +"Properties"
                }
            }

            // Tabs
            div {
                className = ClassName("px-4")
                div {
                    className = ClassName("flex gap-4 md:gap-6 border-b border-border overflow-x-auto")
                    tabs.forEach { tab ->
                        button {
                            key = tab
                            onClick = { setActiveTab(tab) }
                            className = ClassName(
                                if (activeTab == tab)
                                    "py-3 text-sm font-normal transition-colors relative whitespace-nowrap text-foreground border-b-2 border-foreground"
                                else
                                    "py-3 text-sm font-normal transition-colors relative whitespace-nowrap text-boon-muted hover:text-foreground"
                            )
                            +tab
                        }
                    }
                }
            }

            // Property Rows
            div {
//                className = ClassName("flex-1 overflow-auto")
                css(ClassName("flex-1 overflow-auto")) {
                    height = (100.vh - 40.pct)
                }
                filteredProperties.forEach { property ->
//                PropertyRowComponent { this.property = property }
                    ComponentPropertyRow{
                        this.property = property
                    }
                }
            }

            // Save Button
            div {
                className = ClassName("p-4")
                button {
                    className = ClassName("w-full md:w-auto px-6 py-3 bg-boon-primary text-white rounded-lg text-sm font-normal font-serif hover:bg-boon-primary/90 transition-colors")
                    +"Add Property"
                    onClick = {
                        window.location.href = EnumRoutes.AddProperty.routeID
                    }
                }
            }
        }


    }
}

external interface PropertyRowProps : Props {
    var property: PagePropertiesProps
}

val PropertyRowComponent = FC<PropertyRowProps> { props ->
    div {
        className = ClassName("flex items-center gap-4 p-4 border-b border-border")
        img {
            src = props.property.imageUrl
            alt = props.property.name
            className = ClassName("w-16 h-16 rounded-lg object-cover")
        }
        div {
            className = ClassName("flex flex-col")
            span { className = ClassName("text-sm font-medium text-foreground"); +props.property.name }
            span { className = ClassName("text-xs text-boon-muted"); +props.property.address }
        }
        div {
            className = ClassName("ml-auto text-sm text-boon-primary")
            +props.property.price
        }
    }
}